// extracted by mini-css-extract-plugin
export default {"table":"Catalogue_table__Pmxu7","color":"Catalogue_color__uO-P1","sec":"Catalogue_sec__k7hF2"};